parseTokenTimezone